<template lang='pug'>
v-app(style='background: #FFFFFF !important;')
  v-container(fluid, grid-list-xl)
    v-content
      v-layout(row, justify-center)
        v-flex(xs12, sm12, md10, lg9, text-xs-center)
          .review(v-if='sent', color='primary', @click.prevent='')
          v-card(flat)
            breadcrumb(back='page6-15')
              | Estás en: Elige tu Crédito Hipotecario / ¡Quiero elegir la mejor condición para contratar mi Crédito Hipotecario!
            v-card-text.label16tt.withDivider
              span(style='color:#F7893B') PREGUNTA
            v-card-text.titulo24Reg.text-center
              | ¿Qué opción le recomiendas para mejorar las condiciones de su retiro?
            v-card.questionCard(justify-center, flat)
              v-card-text.titulo18Book.text-center
                | Marca la respuesta correcta:
              v-radio-group(v-model='respuesta')
                v-layout.ml-5(v-for='(reactivo, index) in reactivos', :key='index')
                  v-flex.iconos.text-xs-center.pt-3(xs1, align-center, align-content-center)
                    div(v-if='sent && (correctas.includes(index) || respuesta == index)')
                      v-icon(size='15px', color='green', v-if='sent && (correctas.includes(index))') fas fa-check
                      v-icon(size='15px', color='red', v-if='sent && (!correctas.includes(index))') fas fa-times
                  v-flex.iconos.text-xs-right(xs1, align-content-center)
                    v-radio(hide-details, :value='index')
                  v-flex.label16tt_blue.text-xs-left.pr-5(xs12, align-content-center)
                    div(style="display:inline;").mx-2.pr-5.parrafoDestacadoB(v-html="reactivo.descripcion")
            v-layout(row, justify-center)
              v-flex
                div(v-if='sent==false')
                  v-btn.btn(color='secondary', v-bind:class='responseIsNone', :disabled="respuesta=='none'", @click='sendResult()')
                    | Enviar
                div(v-if='sent')
                  v-btn.btn(color='accent', style='z-index:2', @click.prevent='dialog=true')
                    | Ver Retroalimentación
                  v-dialog(v-model='dialog', persistent, max-width='930px')
                    v-layout(row, justify-center)
                      v-flex(text-xs-center)
                        v-card
                          .pt-1.pr-2(v-if='sent && (correctas.includes(respuesta))')
                            v-layout(row, justify-center)
                              v-flex(text-xs-center)
                                img.dialog_img(src='assets/Leccion_1.5_ManoArriba.png')
                            v-spacer.my-1.py-4
                            v-card-text.headline
                              | ¡Bien!
                          .pt-1.pr-2(v-if='sent && (!correctas.includes(respuesta))')
                            v-layout(row, justify-center)
                              v-flex(text-xs-center)
                                img.dialog_img(src='assets/Leccion_1.5_ManoStop.png')
                            v-spacer.my-1.py-4
                            v-card-text.headline
                              | Hay una mejor respuesta...
                          v-card.px-5.questionCard(justify-center, flat)
                            .pt-1.px-5.text-sm-left(v-if='sent && (respuesta==0)')
                              v-card-text.dialog_text
                                | Trabajar toda la vida porque tú quieres está perfecto. Sin embargo, para evitar que esto sea por necesidad, puedes hacer que tu dinero trabaje de diferentes maneras.
                            .pt-1.px-5.text-sm-left(v-if='sent && (respuesta==1)')
                              v-card-text.dialog_text
                                b ¡Excelente consejo! 
                                .pt-3  Las aportaciones voluntarias son una buena opción, las puedes realizar durante toda tu vida laboral. Éstas te dan la oportunidad de sumar ingresos de forma gradual a tu fondo de ahorro para el retiro. Por otro lado, es conveniente pensar en un ingreso extra adicional a la pensión. 
                            .pt-1.px-5.text-sm-left(v-if='sent && (respuesta==2)')
                              v-card-text.dialog_text
                                | La mejor opción siempre es planear cómo disfrutarás tu retiro. Esta es una excelente idea que puede genera un ingreso extra a largo plazo.
                          v-btn.btn.dialog_btn(color='accent', @click.prevent="nextPage('page6-17')")
                            | Siguiente
          l-progress(:value='this.$parent.currentPage')

</template>

<script>
import {
  eventBus
} from '../main';
export default {
  name: 'app',
  data() {
    return {
      reactivos: [{
          descripcion: 'Tener un plan para seguir trabajando toda su vida.',
        },
        {
          descripcion: 'Hacer aportaciones voluntarias a su fondo para el retiro.',
        },
        {
          descripcion: 'Sacar provecho a un Crédito Hipotecario, de nuevo.',
        }
      ],
      selected: [],
      respuesta: 'none',
      response: 0,
      correctas: [1,2],
      sent: false,
      feedback: false,
      dialog: false
    }
  },
  methods: {
    sendResult() {
      if (this.respuesta == this.correcta) {
        this.response = 1;
      }
      this.sent = true;
      eventBus.$emit('send_result', this.response);
    },
    nextPage(page) {
      this.progress = true;
      eventBus.$emit('next_page', page);
    },
    lastPage(page) {
      this.progress = true;
      eventBus.$emit('last_page', page);
    }
  },
  computed: {
    responseIsNone() {
      return {
        'btn-primary': this.respuesta != 'none',
        'btn-secondary': this.respuesta == 'none'
      }
    },
    checkResult() {
      return {
        'done': this.response != 'none',
        'clear': this.response == 'none'
      }
    }
  }
};
</script>
